export default {
    mobileSmall: require('./image-mobile.svg'),
    tvSmall: require('./image-tv.svg'),
    internetSmall: require('./image-fiber.svg'),
    homePhoneSmall: require('./image-mapa.svg'),
    arrowSmall: require('./arrow-small.svg'),
    electricitySmall: require('./image-electricity.svg')
};
